import { toast as sonnerToast } from 'sonner';
import { TOAST_SUCCESS, TOAST_ERROR, TOAST_INFO, TOAST_WARNING } from '@/Poker/data/Constants';
import { MdCheckCircle, MdError, MdInfo, MdWarning } from 'react-icons/md';
import styles from './toast.module.css';

const toastTypeStyles = {
    [TOAST_SUCCESS]: {
        type: 'success',
    },
    [TOAST_ERROR]: {
        type: 'error',
    },
    [TOAST_INFO]: {
        type: 'info',
    },
    [TOAST_WARNING]: {
        type: 'warning',
    },
};

export const CustomToast = ({ type, title, description, t }) => {
    let icon = null;
    let iconClass = styles.gameToastIcon;
    if (type === TOAST_SUCCESS) icon = <MdCheckCircle className={iconClass + ' ' + styles.success} size={24} />;
    else if (type === TOAST_ERROR) icon = <MdError className={iconClass + ' ' + styles.error} size={24} />;
    else if (type === TOAST_INFO) icon = <MdInfo className={iconClass + ' ' + styles.info} size={24} />;
    else if (type === TOAST_WARNING) icon = <MdWarning className={iconClass + ' ' + styles.warning} size={24} />;

    return (
        <div
            className={styles.gameToastContainer}
            onClick={() => sonnerToast.dismiss(t)}
        >
            {icon}
            <div>
                {title && <p className={styles.gameToastTitle + ' ' + styles[toastTypeStyles[type]?.type]}>{title}</p>}
                {description && <p className={styles.gameToastDescription}>{description}</p>}
            </div>
        </div>
    );
}

export const showToast = (type, title, description) => {
    sonnerToast.custom((t) => (
        <CustomToast type={type} title={title} description={description} t={t} />
    ));
} 